import React from 'react'

import ABOUT_US from '../components/Company/About_us'



const About = () => {
  return (
    <>
      
      
    <ABOUT_US/>


    </>
  )
}

export default About
